import React, { useEffect } from "react";
import { HeaderImgSection } from '../../Header/HeaderImgSection'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import slider from '../../../images/DIGITAL MARKETING/DIGITAL-MARKETING-1900-220.png'
import sidebar from '../../../images/DIGITAL MARKETING/Digital-Marketing-Services.png'

function DigitalMarketing() {
  useEffect(() => {
    document.title = "Digital Marketing || OZVASERVICE"
 }, []);
  return (
    <>
      <HeaderImgSection img={slider} hTitle={'Services'} title={"Digital Marketing "}></HeaderImgSection>
      <Container className='my-5'>
        <h1 className='text-center text-primary fw-semibold '>Digital Marketing </h1>
        <p className='text-center'>At OZVA SERVICE, we are your end-to-end partner for comprehensive digital marketing solutions. Our expert team helps businesses thrive online by increasing visibility, driving targeted traffic, and delivering measurable results through strategic, data-driven campaigns.</p>
        <p className='text-center'>We begin by deeply understanding your business goals, industry dynamics, and customer behavior. Based on this analysis, we develop tailored marketing strategies that boost your brand authority, enhance engagement, and improve conversion rates — helping you stand out in a competitive digital space.</p>

        <Row className='my-5 align-items-center'>
          <Col lg={6} className='mb-lg-0 mb-3'>
            <h2 className='text-dark fw-semibold'>Digital Marketing Services</h2>
            <p>Leveraging the full potential of digital platforms, we help you establish a strong brand presence, connect meaningfully with your audience, and drive long-term loyalty. Our marketing experts craft personalized strategies for platforms like Facebook, Instagram, LinkedIn, Twitter, and more.</p>
            <p>We create high-impact content, manage your digital profiles, run paid advertising campaigns, and monitor performance — all to ensure your marketing efforts are optimized for maximum ROI.</p>

            <h2 className='text-dark fw-semibold mb-1'>Marketing Solutions That Fuel Growth</h2>
            {/* <p className='mb-3'>Making a Connection Between Your Brand and Your Customers and Visitors.</p> */}
            <div className="">
              <h5 className='fw-semibold'>Connecting Your Brand with the Right Audience:</h5>
              <p>At OZVA SERVICE, we don’t believe in one-size-fits-all marketing. We deliver customized experiences that align with your unique brand identity and business vision. Our creative strategies are designed to build lasting impressions, increase brand loyalty, and support sustainable business growth.
              </p>
              <p>We give digital marketing a strategic edge — helping you connect the dots between platforms, customer intent, and business results. We’re more than just a marketing firm, we’re your growth partner.</p>
              </div>

          </Col>
          <Col lg={6} className='d-flex justify-content-center align-items-center'>
            <div className="">
              <img src={sidebar} className='img-fluid rounded-2' alt="" />
            </div>
          </Col>
        </Row>

        <h2 className='fw-bold mb-4'>What We Do:</h2>
        <ul>
          <li className='fw-semibold'>Brand Positioning</li>
          <p> - We help position your brand in front of the right audience to maximize exposure and influence.</p>
          <li className='fw-semibold'>Competitive Analysis</li>
          <p> - Stay ahead of your competitors with deep insights into their strengths, weaknesses, and digital activities.</p>
          <li className='fw-semibold'>Product Design and Development</li>
          <p> - Ensure your digital products appeal to your audience — inside and out — with user-centered design and branding.</p>
          <li className='fw-semibold'>Brand Experience Design</li>
          <p> - We enhance every touchpoint of your brand — from user interfaces to messaging — to deliver meaningful, culturally relevant customer experiences.</p>  

        </ul>
        <h2 className='fw-bold my-4'>SEO Services That Work: </h2>
        <p>We offer high-quality SEO services based on proven strategies and white-hat practices. Our core SEO solutions include:</p>
        <ul>
          <li>Keyword Research & Strategy</li>
          <li>Competitor SEO Analysis</li>
          <li>Website Architecture Optimization</li>
          <li>Technical SEO & Code Enhancement</li>
        </ul>

        <h3 className='fw-bold my-4'>Your Trusted SEO Partner: </h3>
        <p>We understand the critical role that search engines play in business success. Our team uses advanced SEO techniques to improve your rankings, visibility, and lead generation. With consistent SEO practices, engaging content, and keyword-rich strategies, we ensure your website stands out on Google and other search engines.</p>
        <p>Partner with OZVA SERVICE — and get the expertise, strategy, and support you need to stay ahead in the digital marketing game.</p>
       
      </Container>
    </>
  )
}

export default DigitalMarketing
